import React from "react";
import Section from "../components/shared/Section";
import { Target, Eye } from "lucide-react";
import { offeringsContent } from "../data/offerings";
import image1 from "../images/gallery/6.jpg";


export default function Offerings() {
  return (
    <Section id="offerings">
      {/* Main grid (same layout as About section) */}
      <div className="grid lg:grid-cols-2 gap-16 items-center text-center sm:text-left">
        {/* Text Content */}
        <div>
          <h2 className="text-3xl sm:text-4xl font-semibold text-white">
            What Do{" "}
            <span className="text-yellow-700 drop-shadow-[0_1px_8px_rgba(255,200,0,0.15)]">
              We Offer?
            </span>
          </h2>

          <p className="mt-6 text-neutral-300 leading-relaxed">
            {offeringsContent.intro}
          </p>
        </div>

        {/* Image Content */}
        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-xl group">
          <img
            src={image1}
            alt="Our Offerings"
            className="h-80 w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/30" />
        </div>
      </div>

      {/* Vision & Goal Section */}
      <div className="mt-10 grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {/* Vision */}
        <div className="flex items-start gap-4 rounded-xl border border-white/10 bg-white/5 p-5 hover:bg-white/10 transition">
          <div className="mt-1">
            <Eye className="h-6 w-6 text-yellow-300" />
          </div>
          <div>
            <h4 className="text-yellow-200 font-semibold text-lg">Vision</h4>
            <p className="text-sm mt-1 text-neutral-300">
              {offeringsContent.vision}
            </p>
          </div>
        </div>

        {/* Goal */}
        <div className="flex items-start gap-4 rounded-xl border border-white/10 bg-white/5 p-5 hover:bg-white/10 transition">
          <div className="mt-1">
            <Target className="h-6 w-6 text-yellow-300" />
          </div>
          <div>
            <h4 className="text-yellow-200 font-semibold text-lg">Goal</h4>
            <p className="text-sm mt-1 text-neutral-300">
              {offeringsContent.goal}
            </p>
          </div>
        </div>
      </div>
    </Section>
  );
}
